import { render, staticRenderFns } from "./AfterLogin.vue?vue&type=template&id=3191bca4"
import script from "./AfterLogin.vue?vue&type=script&lang=js"
export * from "./AfterLogin.vue?vue&type=script&lang=js"
import style0 from "./AfterLogin.vue?vue&type=style&index=0&id=3191bca4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports